import { EventSettings } from '@/types/projects.types';
import { Put } from '../helpers';

export function UpdateEventSettings(event_uuid: string, settings: EventSettings): Promise<EventSettings> {
  return Put({ path: '/v3/admin/events/settings', body: { event_uuid, settings: settings } });
}
